interface Formula {
  description: string;
  required?: boolean;
  tags: string[];
  title: string;
}

export const formulas: Formula[] = [
  {
    description: "（总本金通胀后）",
    required: true,
    tags: ["总本金", "*", "通胀率"],
    title: "通胀本金",
  },
  {
    description: "（不受通胀率影响）",
    tags: ["预付款", "*", "视图周期"],
    title: "总预付款",
  },
  {
    description: "（不受通胀率影响，扣除预付款后）",
    required: true,
    tags: ["（周期结余本金 - 预付款）", "*", "结算周期", "*", "周期收益率"],
    title: "复利总额",
  },
  {
    description: "（通胀后接近当前的购买力为标准）",
    required: true,
    tags: ["通胀本金", "+", "总利润", "-", "总预付款"],
    title: "剩余金额",
  },
  {
    description: "（不受通胀率影响）",
    tags: ["复利总额", "-", "本金"],
    title: "总利润收益",
  },
];
